const CHUNK_RECOVERY_SESSION_KEY = "chatcode.chunk-recovery-attempted";

const CHUNK_LOAD_ERROR_PATTERNS = [
  "failed to fetch dynamically imported module",
  "importing a module script failed",
  "failed to load module script",
  "error loading dynamically imported module",
];

export function isRecoverableChunkLoadError(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (!message) return false;
  const normalized = message.toLowerCase();
  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function shouldAutoReloadForChunkError(): boolean {
  if (typeof window === "undefined") return false;
  try {
    if (window.sessionStorage.getItem(CHUNK_RECOVERY_SESSION_KEY) === "1") {
      return false;
    }
    window.sessionStorage.setItem(CHUNK_RECOVERY_SESSION_KEY, "1");
    return true;
  } catch {
    return false;
  }
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  if (error && typeof error === "object") {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === "string") return maybeMessage;
  }
  return "";
}
